import React from 'react';
import { CautionIcon } from 'ui/Icons';
import { SvgIcon } from 'ui/SvgIcon';

interface IErrorsCellProps {
  errorCount: number;
}

export const ErrorsCell: React.FC<IErrorsCellProps> = ({ errorCount }) => {
  if (errorCount === 0) {
    return <span className="font-pt-sans text-[13px] text-teal-100 font-bold">Upload Ready</span>;
  }
  return (
    <span className="inline-flex items-center gap-1 text-yellow-60 font-pt-sans text-[13px]">
      <SvgIcon IconComponent={CautionIcon} className="w-4 h-4 fill-none stroke-yellow-60" />
      {errorCount}
    </span>
  );
};
